'use strict';

import './dropdown.directive.scss';

export default angular
  .module('maestro.directives.semantic.dropdown', [
    'maestro.services.utils',
    'maestro.filters'
  ])

  .directive('dropdown', function($timeout, $filter, utils) {
    let $t = $filter('translate');
    return {
      restrict: 'E',
      replace: true,
      scope: {
        values: '=',
        selectedKey: '=',
        selectedObj: '=',
        selectedKeys: '=',
        selectedObjs: '=',
        id: '@',
        name: '@',
        key: '@',
        value: '@',
        placeholder: '@',
        colorMark: '@',
        iconMarker: '@',
        translateItem: '<',
        class: '@',
        onChange: '&',
        allowAdditionsInternal: '@allowAdditions',
        allowEmptyInternal: '@allowEmpty'
      },
      controller: ($scope, $element) => {
        $scope.isMultiple = $scope['class'].indexOf('multiple') != -1;

        /**
         * Single dropdown watch result button
         */
        function singleDropDownWatch(selectedKey, values, newVal, oldVal) {
          dropdownClassToggle();

          $timeout(() => {
            $($element).dropdown('set selected', selectedKey);
            $($element).dropdown('set value', selectedKey);
          }, 0);
          $scope.$applyAsync();
        }

        $scope.updateSingleDropDownSelectedValue = function(value, values) {
          let index = utils.inArray(values, $scope.key, value);
          if (index == -1) {
            $scope.selectedValue = null;
            $scope.selectedKey = value;
            $scope.selectedObj = null;
          } else {
            $scope.selectedValue = values[index];
            $scope.selectedKey = values[index][$scope.key];
            $scope.selectedObj = values[index];
          }
          $scope.onChange({ selected: $scope.selectedObj });
        };

        /**
         * Multiple dropdown watch result function
         */
        function multipleDropDownWatch(selectedKeys, values, newVal, oldVal) {
          dropdownClassToggle();
          if ($scope.isOnChanging) {
            return;
          }
          $timeout(function() {
            $($element).dropdown('remove selected', oldVal);
            $($element).dropdown('set selected', newVal);
          }, 10);
        }

        $scope.updateMultipleDropDownSelectedValues = function(value, values) {
          let selectedKeys;
          if (value == null || value == '') {
            selectedKeys = [];
          } else {
            selectedKeys = value.split(',');
          }
          if (selectedKeys == null || values == null || selectedKeys.length == 0) {
            $scope.selectedValue = null;
            $scope.selectedKeys = selectedKeys;
            $scope.selectedObjs = null;
            $scope.onChange({ selected: $scope.selectedObjs });
            return;
          }
          let selectedItems = new Array();
          for (let i = 0; i < selectedKeys.length; i++) {
            let itemId = selectedKeys[i];
            let index = utils.inArray(values, $scope.key, itemId);
            if (index != -1) {
              selectedItems.push(values[index]);
            }
          }
          $scope.selectedKeys = selectedKeys;
          $scope.selectedValue = 'Placeholder'; // Don't remove
          $scope.selectedObjs = selectedItems;
          $scope.onChange({ selected: $scope.selectedObjs });
        };

        /**
         * Support function to manipulate "clear" icon
         */
        function dropdownClassToggle() {
          if ($scope.isMultiple) {
            if ($scope.selectedKeys && $scope.selectedKeys.length > 0) {
              $($element).addClass('filled');
            } else {
              $($element).removeClass('filled');
            }
          } else {
            if ($scope.allowEmpty) {
              if ($scope.selectedKey || $scope.selectedKey === 0) {
                $($element).addClass('filled');
              } else {
                $($element).removeClass('filled');
              }
            }
          }
        }

        $scope.repeatComplete = function() {
          if ($scope.isMultiple) {
            let val = ($scope.selectedKeys && $scope.selectedKeys.length > 0) ? $scope.selectedKeys.join(',') : null;
            $scope.updateMultipleDropDownSelectedValues(val, $scope.values);
            // Start watch for changes
            $scope.$watchCollection('selectedKeys', function(newVal, oldVal) {
              // Prevent multiple triggers at initialization
              if (newVal === oldVal && newVal === undefined) {
                return;
              }
              multipleDropDownWatch($scope.selectedKeys, $scope.values, newVal, oldVal);
            });
          } else {
            $scope.updateSingleDropDownSelectedValue($scope.selectedKey, $scope.values);
            // Start watch for changes
            $scope.$watch('selectedKey', function(newVal, oldVal) {
              // Prevent multiple triggers at initialization
              if (newVal === oldVal && newVal === undefined) {
                return;
              }
              singleDropDownWatch($scope.selectedKey, $scope.values, newVal, oldVal);
            });
          }
        };

        $scope.resetDropdown = function($event) {

          // Hide dropdown on click on clear icon
          if ($event) {
            $event.stopPropagation();
          }

          // Should became undefined
          delete $scope.selectedKey;

          if ($scope.isMultiple) {
            $scope.updateMultipleDropDownSelectedValues(null, $scope.values);
          } else {
            $scope.updateSingleDropDownSelectedValue(null, $scope.values);
          }
        };

        /**
         * Fix placeholder color
         * When placeholder selected from the options list
         */
        $scope.selectPlaceholder = function(flag) {
          let className = '';
          if ($scope.allowEmpty && flag) {
            $scope.resetDropdown();
            className = ' grey-placeholder';
          }
          $scope.placeholderClass = className;
          updatePlaceholderText();
        };

        // Both watchers was here previously

        // We really need to do it that way. To execute function every digest cycle
        // When semantic initialize something in modal window, and the modal initially hidden - it clears the placeholder for good
        // Removing `text` class from placeholder div will help too.
        $scope.$watch(() => {
          updatePlaceholderText();
        }, () => {

        });

        function updatePlaceholderText() {
          if (!$scope.searchValue) {
            let placeholder = $scope.selectedValue ? $scope.selectedValue[$scope.value] : $scope.placeholder;
            if ($scope.translateItem && ($scope.translateItem === 'true' || $scope.translateItem === true)) {
              placeholder = $t(placeholder);
            }
            $($element).find('div.dropdown-placeholder').text(placeholder || '');
          } else if (!$scope.selectedValue) {
            $($element).find('div.dropdown-placeholder').text('');
          }
        }

      },
      link: function($scope, $element) {
        $scope.elementId = $scope.id;
        $scope.allowAdditions = $scope.allowAdditionsInternal == 'true' ? true : false;
        $scope.allowEmpty = $scope.allowEmptyInternal == 'true' ? true : false;
        $scope.isMultiple = $($element).hasClass('multiple');

        $($element).dropdown({
          message: {
            addResult: $t('dropdown.message.addResult'),
            count: $t('dropdown.message.count'),
            maxSelections: $t('dropdown.message.maxSelections'),
            noResults: $t('dropdown.message.noResults')
          },
          allowAdditions: $scope.allowAdditions,
          fullTextSearch: true,
          onChange: function(value, text, $selectedItem) {
            $scope.$applyAsync(() => {
              $scope.isOnChanging = true;
              if ($scope.isMultiple) {
                $scope.updateMultipleDropDownSelectedValues(value, $scope.values);
              } else {
                $scope.updateSingleDropDownSelectedValue(value, $scope.values);
              }
              $scope.isOnChanging = false;
            });
          }
        });
      },
      template: function(tElement, tAttrs) {
        let isMultiple = $(tElement).hasClass('multiple');
        let defaultStr = (tAttrs.allowEmpty && tAttrs.allowEmpty == 'true' && !isMultiple)
          ? '<div class="item" ng-click="selectPlaceholder(true)" data-value="">{{placeholder}}</div>'
          : '';
        let translateStr = '';
        if (tAttrs.translateItem && tAttrs.translateItem == 'true') {
          translateStr = ' | translate';
        }

        // Add color marks and icon markers
        let colorMarkIcon = !!tAttrs.colorMark ? 'fa-' + tAttrs.colorMark : '';
        let markerIcon = (!isMultiple && !colorMarkIcon && !!tAttrs.iconMarker) ? 'fa-' + tAttrs.iconMarker : '';

        // Fix for searchable dropdown
        let searchInput = $(tElement).hasClass('search')
          ? `<input class="search ${!!markerIcon && 'has-marker'}" ng-model="searchValue" autocomplete="none" tabindex="0"/>`
          : '';

        return `<div class="ui selection dropdown {{class}}">
          ${colorMarkIcon && `<icon i="fas ${colorMarkIcon}" class="marker icon {{(selectedObj && selectedObj.color) || 'grey'}}" ng-show="!!selectedObj"></icon>`}
          ${markerIcon && `<icon i="far ${markerIcon}" class="marker-small icon grey grow-1"></icon>`}
          <input type="hidden" name="${tAttrs.id || tAttrs.name}"/>
          <icon i="fas fa-caret-down" class="fa-caret-down icon"></icon>
          ${searchInput}
          <div class="dropdown-placeholder text{{placeholderClass}}" ng-class="{'default': (!selectedValue)}"></div>
          <i ng-click="resetDropdown($event)" ng-show="allowEmpty && !!selectedValue" class="cancel link icon" style="z-index:100;"></i>
          <div class="menu">
            ${defaultStr}
            <div repeat-complete="repeatComplete()"
                 ng-repeat="value in values"
                 class="item"
                 ng-class="{'active selected': selectedValue.${tAttrs.key} == value.${tAttrs.key} }"
                 ng-click="selectPlaceholder()"
                 data-obj="{{value}}"
                 data-value="{{value.${tAttrs.key} }}">
              ${colorMarkIcon
          ? `<icon i="fas ${colorMarkIcon}" class="marker icon {{(value && value.color) ? value.color : 'grey'}}"></icon>`
          : ``}{{value.${tAttrs.value}${translateStr} }}
            </div>
          </div>
        </div>`;
      }
    };
  })

  .name;
